export const generateChargueData = (
  products_data,
  tipoCDP,
  ruc,
  razsoc,
  facdir,
  mail_confirm,
  operation_number,
  id_delivery,
  address_details,
  day_delivery,
  ruc_agency,
  dir_agency,
  origin_bank,
  destiny_bank,
) => {
  const chargueData = {
    sales_detail: products_data,
    factura: false,
    ruc: tipoCDP == 2 ? ruc : null,
    companyName: tipoCDP == 2 ? razsoc : null,
    billing_address: tipoCDP == 2 ? facdir : null,
    mail_confirm: mail_confirm,
    operation_number: operation_number,
    origin_bank: origin_bank,
    destiny_bank: destiny_bank,
    detalle_despacho: {
      id_despacho: { id_delivery: id_delivery },
      cod_ubigeo: !address_details ? '' : address_details.id_district.cod_ubigeo,
      detalle_ubicacion: !address_details
        ? ''
        : address_details.address +
          ', ' +
          address_details.id_district.desc_district +
          ', ' +
          address_details.id_district.province.desc_province +
          ', ' +
          address_details.id_district.province.departament.desc_departament,
      dia_entrega: day_delivery,
      cod_erp_direccion: !address_details ? '' : address_details.cod_erp,
      transport_company: ruc_agency,
      transport_company_address: dir_agency,
      cod_ubigeo_transport_company:
        dir_agency === '' ? '' : transport_address_details.id_district.cod_ubigeo,
    },
  };
  return chargueData;
};

export const generateChargueDataForVisanet = (
  token_transaction,
  niubizSecurityToken,
  loggedUserData,
  products_data,
  tipoCDP,
  ruc,
  razsoc,
  facdir,
  mail_confirm,
  operation_number,
  id_delivery,
  address_details,
  day_delivery,
  ruc_agency,
  dir_agency,
  origin_bank,
  destiny_bank,
) => {
  const chargueData = {
    tokenID: token_transaction,
    securityToken: niubizSecurityToken,
    email: loggedUserData.email_client,
    sales_detail: products_data,
    factura: false,
    ruc: tipoCDP == 2 ? ruc : null,
    companyName: tipoCDP == 2 ? razsoc : null,
    billing_address: tipoCDP == 2 ? facdir : null,
    mail_confirm: mail_confirm,
    operation_number: operation_number,
    origin_bank: origin_bank,
    destiny_bank: destiny_bank,
    detalle_despacho: {
      id_despacho: { id_delivery: id_delivery },
      cod_ubigeo: !address_details ? '' : address_details.id_district.cod_ubigeo,
      detalle_ubicacion: !address_details
        ? ''
        : address_details.address +
          ', ' +
          address_details.id_district.desc_district +
          ', ' +
          address_details.id_district.province.desc_province +
          ', ' +
          address_details.id_district.province.departament.desc_departament,
      dia_entrega: day_delivery,
      cod_erp_direccion: !address_details ? '' : address_details.cod_erp,
      transport_company: ruc_agency,
      transport_company_address: dir_agency,
      cod_ubigeo_transport_company:
        dir_agency === '' ? '' : transport_address_details.id_district.cod_ubigeo,
    },
  };
  return chargueData;
};

export const generateNewAccountForErpRequest = (
  tipoCDP,
  loggedUserData,
  ruc,
  razsoc,
  address_details,
) => {
  const newAccountForErpRequest = {
    id: tipoCDP == 2 ? ruc : loggedUserData.dni_client,
    nombre: tipoCDP == 2 ? razsoc : loggedUserData.name_client,
    evento: 'N',
    direccion: loggedUserData.address_client,
    tipo_Documento: 6,
    moneda: 'SOL',
    email: loggedUserData.email_client,
    telefono: loggedUserData.phone_client,
    codigo_Vendedor: '151',
    codigo_Cobrador: '90',
    codigo_Sectorista: 'BAGUILAR',
    direccion_Embarque: address_details.cod_erp,
    ubigeo: !address_details.id_district.cod_ubigeo ? '' : address_details.id_district.cod_ubigeo,
  };
  return newAccountForErpRequest;
};
